/**
 * B&B Style Carousel - Best Sellers Section
 * Self-built quick-add modal via Shopify Product JSON API
 * Features: square image, color swatches with names, image switching, single-page modal
 */

(function () {
  'use strict';

  var qaModal = null;
  var qaOverlay = null;
  var qaState = { product: null, selectedOptions: {} };

  function ensureQuickAddModal() {
    if (qaModal) return;
    qaOverlay = document.createElement('div');
    qaOverlay.className = 'bb-qa-overlay';
    qaOverlay.addEventListener('click', function (e) {
      if (e.target === qaOverlay) closeQuickAdd();
    });
    qaModal = document.createElement('div');
    qaModal.className = 'bb-qa-modal';
    qaOverlay.appendChild(qaModal);
    document.body.appendChild(qaOverlay);
  }

  function closeQuickAdd() {
    if (qaOverlay) qaOverlay.classList.remove('bb-qa-open');
    document.body.classList.remove('bb-qa-lock');
  }

  function formatMoney(cents) {
    if (typeof window.theme === 'object' && window.theme.settings && window.theme.settings.moneyFormat) {
      var format = window.theme.settings.moneyFormat;
      var amount = (cents / 100).toFixed(2);
      return format.replace(/\{\{amount\}\}/g, amount)
        .replace(/\{\{ amount \}\}/g, amount)
        .replace(/\{\{amount_with_comma_separator\}\}/g, amount.replace('.', ','))
        .replace(/\$\{/g, '$').replace(/\}/g, '');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Get variant image URL at a given size
  function getVariantImage(product, selectedOptions) {
    var variant = findVariant(product, selectedOptions);
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (product.featured_image) {
      return product.featured_image;
    }
    return '';
  }

  // Resize Shopify image URL to target size
  function resizeImage(url, size) {
    if (!url) return '';
    // Shopify CDN supports _SIZE suffix for resizing: file_60x60.webp
    // Also handle URLs with query params like ?v=123
    var match = url.match(/^([^?]+)(\?.*)?$/);
    if (!match) return url;
    var basePath = match[1];
    var queryStr = match[2] || '';
    return basePath.replace(/(\.(jpg|jpeg|png|webp|gif))/i, '_' + size + '$1') + queryStr;
  }

  function openQuickAdd(handle, presetColorValue) {
    ensureQuickAddModal();
    qaModal.innerHTML = '<div class="bb-qa-loading">Loading…</div>';
    qaOverlay.classList.add('bb-qa-open');
    document.body.classList.add('bb-qa-lock');

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        qaState.product = product;
        qaState.selectedOptions = {};
        product.options.forEach(function (opt) {
          var isColor = /color|colour/i.test(opt.name);
          if (isColor && presetColorValue && opt.values.indexOf(presetColorValue) !== -1) {
            qaState.selectedOptions[opt.name] = presetColorValue;
          } else {
            qaState.selectedOptions[opt.name] = opt.values[0];
          }
        });
        renderQuickAdd(product);
      })
      .catch(function () {
        qaModal.innerHTML = '<div class="bb-qa-error">Failed to load product. <a href="/products/' + handle + '">View full product page</a></div>';
      });
  }

  function findVariant(product, selectedOptions) {
    return product.variants.find(function (v) {
      return v.options.every(function (optVal, i) {
        return optVal === selectedOptions[product.options[i].name];
      });
    });
  }

  // Build color swatch style from variant
  function getColorSwatchStyle(product, optionName, value) {
    // Try to find a variant with this color value to get its image
    var optionIndex = product.options.findIndex(function (o) { return o.name === optionName; });
    var variant = product.variants.find(function (v) {
      return v.options[optionIndex] === value;
    });

    // Use the variant's featured image as the swatch background if available
    if (variant && variant.featured_image && variant.featured_image.src) {
      var swatchUrl = resizeImage(variant.featured_image.src, '60x60');
      // Use url() without quotes to avoid conflict with style attribute quotes
      return 'background-image: url(' + swatchUrl + '); background-size: cover; background-position: center;';
    }

    // Fallback: use CSS color name
    var cssColor = value.toLowerCase().replace(/\s+/g, '');
    var colorMap = {
      'white': '#ffffff', 'cream': '#fffbf0', 'skyblue': '#87ceeb', 'orange': '#ff8c00',
      'treemosskgreen': '#8a9a5b', 'treemosskgeen': '#8a9a5b', 'aqua': '#5cb8b8', 'aquamarine': '#5cb8b8',
      'teal': '#008080', 'navy': '#1a2f51', 'silver': '#c0c0c0', 'darkgrey': '#444444', 'babypink': '#f4c2c2',
      'lavender': '#b57edc', 'matchagreen': '#7a8b5b', 'vermillion': '#e34234',
      'eggplant': '#614051', 'olive': '#808000', 'lightgrey': '#d3d3d3', 'black': '#000000',
      'oxford': '#002147', 'burgundy': '#800020', 'emerald': '#50c878', 'darkkhaki': '#bdb76b',
      'gray': '#808080', 'darkgray': '#555555'
    };
    var bgColor = colorMap[cssColor] || cssColor;
    return 'background-color: ' + bgColor + ';';
  }

  function renderQuickAdd(product) {
    var imgUrl = getVariantImage(product, qaState.selectedOptions);
    if (imgUrl) imgUrl = resizeImage(imgUrl, '500x500');

    var currentVariant = findVariant(product, qaState.selectedOptions);
    var priceHtml = '';
    if (currentVariant) {
      var price = currentVariant.price;
      var compareAt = currentVariant.compare_at_price;
      if (compareAt && compareAt > price) {
        priceHtml = '<span class="bb-qa-price bb-qa-price--sale">' + formatMoney(price) + '</span>' +
          '<span class="bb-qa-price bb-qa-price--original">' + formatMoney(compareAt) + '</span>';
      } else {
        priceHtml = '<span class="bb-qa-price">' + formatMoney(price) + '</span>';
      }
    }

    // Build option groups - color options get special swatch treatment
    var optionsHtml = product.options.map(function (opt) {
      var isColor = /color|colour/i.test(opt.name);
      var labelText = isColor ? opt.name : opt.name;
      var currentVal = qaState.selectedOptions[opt.name];

      if (isColor) {
        // Color swatches with small color name label
        var swatches = opt.values.map(function (val) {
          var isSelected = currentVal === val;
          var swatchStyle = getColorSwatchStyle(product, opt.name, val);
          return '<button type="button" class="bb-qa-swatch' + (isSelected ? ' bb-qa-swatch--selected' : '') + '"' +
            ' data-option="' + encodeURIComponent(opt.name) + '"' +
            ' data-value="' + encodeURIComponent(val) + '"' +
            ' title="' + val + '"' +
            ' style="' + swatchStyle + '"' +
            '></button>';
        }).join('');

        return '<div class="bb-qa-option-group bb-qa-option-group--color">' +
          '<div class="bb-qa-color-header">' +
            '<label class="bb-qa-option-label">' + labelText + '</label>' +
            '<span class="bb-qa-color-name">' + currentVal + '</span>' +
          '</div>' +
          '<div class="bb-qa-swatches">' + swatches + '</div>' +
          '</div>';
      } else {
        // Regular text buttons for Size etc.
        var buttons = opt.values.map(function (val) {
          var isSelected = currentVal === val;
          return '<button type="button" class="bb-qa-option-btn' + (isSelected ? ' bb-qa-option-btn--selected' : '') + '"' +
            ' data-option="' + encodeURIComponent(opt.name) + '"' +
            ' data-value="' + encodeURIComponent(val) + '"' +
            '>' + val + '</button>';
        }).join('');

        return '<div class="bb-qa-option-group">' +
          '<label class="bb-qa-option-label">' + labelText + '</label>' +
          '<div class="bb-qa-options">' + buttons + '</div>' +
          '</div>';
      }
    }).join('');

    var soldOut = currentVariant && !currentVariant.available;

    qaModal.innerHTML =
      '<button class="bb-qa-close" aria-label="Close">&times;</button>' +
      '<div class="bb-qa-content">' +
        '<div class="bb-qa-image-wrap">' +
          (imgUrl ? '<img class="bb-qa-image" src="' + imgUrl + '" alt="' + product.title + '" />' : '') +
        '</div>' +
        '<div class="bb-qa-info">' +
          '<h3 class="bb-qa-title">' + product.title + '</h3>' +
          '<div class="bb-qa-price-row">' + priceHtml + '</div>' +
          optionsHtml +
          '<button type="button" class="bb-qa-add-to-cart"' + (soldOut ? ' disabled' : '') + '>' +
            (soldOut ? 'Sold Out' : 'Add to Cart') +
          '</button>' +
        '</div>' +
      '</div>';

    qaModal.querySelector('.bb-qa-close').addEventListener('click', closeQuickAdd);

    // Bind color swatches
    qaModal.querySelectorAll('.bb-qa-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optName = decodeURIComponent(btn.getAttribute('data-option'));
        var optVal = decodeURIComponent(btn.getAttribute('data-value'));
        qaState.selectedOptions[optName] = optVal;

        // Update selected state
        qaModal.querySelectorAll('.bb-qa-swatch').forEach(function (b) { b.classList.remove('bb-qa-swatch--selected'); });
        btn.classList.add('bb-qa-swatch--selected');

        // Update color name label
        var colorName = qaModal.querySelector('.bb-qa-color-name');
        if (colorName) colorName.textContent = optVal;

        // Update main image
        var newImgUrl = getVariantImage(qaState.product, qaState.selectedOptions);
        if (newImgUrl) {
          var img = qaModal.querySelector('.bb-qa-image');
          if (img) img.src = resizeImage(newImgUrl, '500x500');
        }

        updatePriceAndButton();
      });
    });

    // Bind regular option buttons
    qaModal.querySelectorAll('.bb-qa-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optName = decodeURIComponent(btn.getAttribute('data-option'));
        var optVal = decodeURIComponent(btn.getAttribute('data-value'));
        qaState.selectedOptions[optName] = optVal;

        var group = btn.closest('.bb-qa-option-group');
        group.querySelectorAll('.bb-qa-option-btn').forEach(function (b) { b.classList.remove('bb-qa-option-btn--selected'); });
        btn.classList.add('bb-qa-option-btn--selected');

        updatePriceAndButton();
      });
    });

    function updatePriceAndButton() {
      var newVariant = findVariant(qaState.product, qaState.selectedOptions);
      var priceRow = qaModal.querySelector('.bb-qa-price-row');
      var addBtn = qaModal.querySelector('.bb-qa-add-to-cart');
      if (newVariant && priceRow && addBtn) {
        var p = newVariant.price;
        var ca = newVariant.compare_at_price;
        if (ca && ca > p) {
          priceRow.innerHTML = '<span class="bb-qa-price bb-qa-price--sale">' + formatMoney(p) + '</span><span class="bb-qa-price bb-qa-price--original">' + formatMoney(ca) + '</span>';
        } else {
          priceRow.innerHTML = '<span class="bb-qa-price">' + formatMoney(p) + '</span>';
        }
        if (newVariant.available) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
      }
    }

    // Bind add to cart
    var addToCartBtn = qaModal.querySelector('.bb-qa-add-to-cart');
    if (addToCartBtn && !soldOut && currentVariant) {
      addToCartBtn.addEventListener('click', function () {
        var variant = findVariant(qaState.product, qaState.selectedOptions);
        if (!variant) return;
        addToCartBtn.textContent = 'Adding…';
        addToCartBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        })
        .then(function () { closeQuickAdd(); window.location.href = '/cart'; })
        .catch(function () { addToCartBtn.textContent = 'Error - Try Again'; addToCartBtn.disabled = false; });
      });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && qaOverlay && qaOverlay.classList.contains('bb-qa-open')) closeQuickAdd();
  });

  // ============================================
  // Carousel Section
  // ============================================
  function initBBCarousel(sectionId) {
    var section = document.getElementById('BBCarousel-' + sectionId);
    if (!section || section.getAttribute('data-bb-init') === 'true') return;
    section.setAttribute('data-bb-init', 'true');

    var track = section.querySelector('.bb-carousel__track');
    var inner = section.querySelector('.bb-carousel__inner');
    var prevBtn = section.querySelector('.bb-carousel__arrow--prev');
    var nextBtn = section.querySelector('.bb-carousel__arrow--next');
    var progressBar = section.querySelector('.bb-carousel__progress-bar');
    if (!track || !inner) return;

    inner.style.position = 'relative';

    function rewriteBadges() {
      var badges = section.querySelectorAll('.jdgm-preview-badge');
      badges.forEach(function (badge) {
        var innerBadge = badge.querySelector('.jdgm-prev-badge');
        if (!innerBadge) return;
        var rating = innerBadge.getAttribute('data-average-rating') || '0';
        var reviewCount = innerBadge.getAttribute('data-number-of-reviews') || '0';
        if (rating === '0.00' || parseFloat(rating) === 0) return;
        var ratingFormatted = parseFloat(rating).toFixed(1);
        var countNum = parseInt(reviewCount);
        var countFormatted = countNum >= 1000 ? (countNum / 1000).toFixed(1) + 'k' : String(countNum);
        badge.innerHTML = '<span class="bb-rating"><svg class="bb-rating__star" fill="currentColor" height="14" viewBox="0 0 32 32" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M29.2862 14.3562L23.6612 19.2099L25.3749 26.4687C25.4695 26.8628 25.4451 27.276 25.3049 27.6562C25.1648 28.0364 24.9184 28.3665 24.5873 28.6049C24.2562 28.8432 23.8572 28.9731 23.4637 28.9954C23.0701 29.0179 22.682 28.9075 22.3124 28.6962L15.9999 24.8112L9.68369 28.6962C9.3141 28.9063 8.92512 29.0094 8.53359 28.9926C8.14207 28.9758 7.7392 28.8397 7.4122 28.6016C7.08519 28.3636 6.83851 28.0355 6.69851 27.6562C6.55852 27.277 6.53465 26.8622 6.62491 26.4687L8.34491 19.2099L2.71991 14.3562C2.41404 14.0918 2.19283 13.7431 2.0839 13.354C1.97497 12.965 1.97483 12.5517 2.08667 12.167C2.19851 11.7822 2.41325 11.4439 2.78271 11.1907C3.15218 10.9375 3.66765 10.7854 4.16492 10.7499L11.2599 10.1549L14.1049 3.26996C14.2589 2.89473 14.521 2.57377 14.8578 2.34788C15.1946 2.122 15.5901 2.00204 15.9968 2.00204C16.4036 2.00204 16.799 2.122 17.1358 2.34788C17.4726 2.57377 17.7347 2.89473 17.8887 3.26996L20.739 10.1549L27.8268 10.7499C28.3238 10.7852 28.8404 10.9374 29.2096 11.1905C29.5787 11.4435 29.7934 11.7819 29.9053 12.1671C30.0171 12.5523 30.0169 12.9656 29.908 13.3548C29.799 13.744 29.5782 14.0928 29.2723 14.3562L29.2862 14.3562Z" fill="currentColor"/></svg><span class="bb-rating__score">' + ratingFormatted + '</span><span class="bb-rating__divider"></span><span class="bb-rating__count">' + countFormatted + ' Reviews</span></span>';
        badge.setAttribute('data-bb-rewritten', 'true');
      });
    }

    rewriteBadges();
    setTimeout(rewriteBadges, 500);
    setTimeout(rewriteBadges, 1500);
    setTimeout(rewriteBadges, 3000);

    var badgeObserver = new MutationObserver(function () { rewriteBadges(); });
    section.querySelectorAll('.jdgm-preview-badge').forEach(function (badge) {
      badgeObserver.observe(badge, { childList: true, subtree: true, attributes: true });
    });

    function bindQuickAdd() {
      section.querySelectorAll('.bb-carousel__add-btn').forEach(function (btn) {
        if (btn.getAttribute('data-bb-bound') === 'true') return;
        btn.setAttribute('data-bb-bound', 'true');
        var nameVal = btn.getAttribute('name') || '';
        var isSingleVariant = /^\d+$/.test(nameVal);
        if (isSingleVariant) {
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            btn.style.opacity = '0.5';
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(nameVal), quantity: 1 }) })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () { btn.style.opacity = '1'; });
          });
        } else {
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            if (!nameVal) return;
            // Pass through whichever color swatch is currently selected on this
            // card, so the quick-add modal opens pre-set to that same color.
            var card = btn.closest('.bb-carousel__card');
            var selectedSwatch = card ? card.querySelector('.bb-carousel__swatch--selected') : null;
            var presetColor = selectedSwatch ? selectedSwatch.getAttribute('data-color-value') : null;
            openQuickAdd(nameVal, presetColor);
          });
        }
      });
    }
    setTimeout(bindQuickAdd, 300);
    setTimeout(bindQuickAdd, 1500);

    // Clicking a color swatch on the card itself (not the quick-add modal)
    // swaps the card's main image to that color's variant image and marks
    // it selected, so the swatch choice is reflected before quick-add opens.
    function bindCardSwatches() {
      section.querySelectorAll('.bb-carousel__swatch').forEach(function (swatch) {
        if (swatch.getAttribute('data-bb-swatch-bound') === 'true') return;
        swatch.setAttribute('data-bb-swatch-bound', 'true');
        swatch.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var swatches = swatch.parentElement;
          if (swatches) {
            swatches.querySelectorAll('.bb-carousel__swatch').forEach(function (s) {
              s.classList.remove('bb-carousel__swatch--selected');
            });
          }
          swatch.classList.add('bb-carousel__swatch--selected');

          var newImageUrl = swatch.getAttribute('data-variant-image');
          var card = swatch.closest('.bb-carousel__card');
          var img = card ? card.querySelector('.bb-carousel__image') : null;
          if (newImageUrl && img) {
            img.src = newImageUrl;
            img.srcset = '';
          }
        });
      });
    }
    bindCardSwatches();
    setTimeout(bindCardSwatches, 300);
    setTimeout(bindCardSwatches, 1500);

    var slides = inner.querySelectorAll('.bb-carousel__slide');
    var isDesktop = window.matchMedia('(min-width: 769px)').matches;
    var slideWidth = 0, visibleWidth = 0, currentSlideIndex = 0;

    function calculateDimensions() {
      isDesktop = window.matchMedia('(min-width: 769px)').matches;
      if (slides.length === 0) return;
      slideWidth = slides[0].offsetWidth;
      var gap = parseInt(window.getComputedStyle(inner).gap) || 16;
      visibleWidth = track.offsetWidth;
      // Both desktop and mobile use left-based movement
      currentSlideIndex = 0;
      inner.style.transition = 'none';
      inner.style.left = '0px';
      track.scrollLeft = 0;
      updateProgressDesktop();
      updateArrowStateDesktop();
    }
    function getStep() { return slideWidth + (parseInt(window.getComputedStyle(inner).gap) || 16); }
    function getMaxIndex() { var m = slides.length - Math.ceil(visibleWidth / getStep()); return m < 1 ? slides.length - 1 : m; }
    function updateArrowStateDesktop() { if (prevBtn) prevBtn.disabled = currentSlideIndex <= 0; if (nextBtn) nextBtn.disabled = currentSlideIndex >= getMaxIndex(); }
    function updateArrowStateMobile() { var ms = track.scrollWidth - track.clientWidth; if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0; if (nextBtn) nextBtn.disabled = track.scrollLeft >= ms - 1; }
    function updateProgressDesktop() { if (progressBar) { var p = currentSlideIndex / getMaxIndex(); progressBar.style.width = Math.min(1, Math.max(0.15, p * 0.85 + 0.15)) * 100 + '%'; } }
    function updateProgressMobile() { if (progressBar) { var ms = track.scrollWidth - track.clientWidth; var p = ms <= 0 ? 1 : track.scrollLeft / ms; progressBar.style.width = Math.min(1, Math.max(0.15, p * 0.85 + 0.15)) * 100 + '%'; } }
    function slideDesktop(dir) { currentSlideIndex = Math.max(0, Math.min(getMaxIndex(), currentSlideIndex + dir)); inner.style.transition = 'left 0.35s ease-in-out'; inner.style.left = -(currentSlideIndex * getStep()) + 'px'; updateArrowStateDesktop(); updateProgressDesktop(); }
    function slideMobile(dir) { slideDesktop(dir); }
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (isDesktop) slideDesktop(-1); else slideMobile(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (isDesktop) slideDesktop(1); else slideMobile(1); });
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (isDesktop) return;
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { updateProgressDesktop(); updateArrowStateDesktop(); }, 50);
    });
    var resizeTimer = null;
    window.addEventListener('resize', function () { if (resizeTimer) clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { currentSlideIndex = 0; inner.style.transition = 'none'; inner.style.left = '0px'; track.scrollLeft = 0; calculateDimensions(); }, 200); });
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDirectionLocked = false;
    var touchIsHorizontal = false;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDirectionLocked = false;
      touchIsHorizontal = false;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!touchDirectionLocked) {
        var dx = Math.abs(e.touches[0].clientX - touchStartX);
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > 10 || dy > 10) {
          touchDirectionLocked = true;
          touchIsHorizontal = dx > dy;
        }
      }
      // If vertical, let page scroll - don't preventDefault
      if (touchDirectionLocked && !touchIsHorizontal) return;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var touchEndX = e.changedTouches[0].clientX;
      var diff = touchStartX - touchEndX;
      
      // If direction wasn't determined or was vertical, do nothing
      if (!touchDirectionLocked || !touchIsHorizontal) return;
      
      if (Math.abs(diff) < 30) return; // too small, ignore
      
      // Both desktop and mobile use the same slide logic (left-based)
      var dir = diff > 0 ? 1 : -1;
      slideDesktop(dir);
    }, { passive: true });
    calculateDimensions();
    window.addEventListener('load', calculateDimensions);
  }

  function initAll() {
    document.querySelectorAll('.bb-carousel-section').forEach(function (section) {
      var sectionId = section.id ? section.id.replace('BBCarousel-', '') : null;
      if (sectionId) initBBCarousel(sectionId);
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bb-carousel-section');
    if (section) { var sectionId = section.id ? section.id.replace('BBCarousel-', '') : null; if (sectionId) initBBCarousel(sectionId); }
  });
})();